import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'
import i18n from '@/locales'
import ElementUI from 'element-ui'
import '@/styles/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import '@kkday/web-design-system/dist/v2.7/core.css'
import '@kkday/web-design-system/dist/v2.7/components.css'
import '@kkday/web-design-system/dist/v2.7/assets/css/_design_tokens.css'
import '@/styles/index.less'
import Vuelidate from 'vuelidate'
import initCommonConponents from '@/kkpar-ds'
import VueClipboard from 'vue-clipboard2'
import { mixpanelInit } from '@/libs/mixpanel'
import { getErrorMsg } from '@/utils/tool'
import vueEsign from 'vue-esign'

import registerDirectives from '@/utils/directives.js'
registerDirectives(Vue) // 注册自定义指令
VueClipboard.config.autoSetContainer = true

Vue.prototype.$getErrorMsg = getErrorMsg

mixpanelInit()
Vue.use(vueEsign)
Vue.use(VueClipboard)
Vue.use(initCommonConponents)
Vue.use(Vuelidate)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
